import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-save-view-name-dialog',
  templateUrl: './save-view-name-dialog.component.html',
  styleUrls: ['./save-view-name-dialog.component.scss'],
})
export class SaveViewNameDialogComponent {
  viewName = '';

  constructor(
    private dialogRef: NbDialogRef<SaveViewNameDialogComponent>,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  save(): void {
    const name = this.viewName.trim();
    if (!name) {
      this.toastr.warning(this.translate.instant('KPI.SAVED_VIEWS.NAME_REQUIRED'));
      return;
    }
    this.dialogRef.close(name);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
